<template>
  <div id="kids-bmi">
    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1">
      <b-form-group :label="$t('tools.cole.gender')" label-for="edit-name">
        <b-form-select v-model="gender">
          <option value="M">{{ $t('tools.cole.boy') }}</option>
          <option value="F">{{ $t('tools.cole.girl') }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group :label="$t('tools.age')" label-for="edit-age">
        <div class="tw-grid tw-grid-cols-2 tw-gap-2">
          <b-input-group :append="$t('tools.append.age')">
            <b-form-input id="edit-age" v-model="years" :placeholder="$t('tools.cole.placeholder.years')"
                          type="text" inputmode="numeric"
            ></b-form-input>
          </b-input-group>
          <b-input-group :append="$t('tools.append.months')">
            <b-form-input id="edit-months" v-model="months" :placeholder="$t('tools.cole.placeholder.months')"
                          :aria-label="$t('tools.append.months')" type="text" inputmode="numeric"
            ></b-form-input>
          </b-input-group>
        </div>
      </b-form-group>

      <b-form-group :label="$t('tools.height')" label-for="edit-height">
        <b-input-group :append="$t('tools.append.height')">
          <b-form-input id="edit-height" v-model="height"
                        :placeholder="$t('tools.cole.placeholder.height')" type="text"
                        v-decimal
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <b-form-group :label="$t('tools.weight')" label-for="edit-weight">
        <b-input-group :append="$t('tools.append.weight')">
          <b-form-input id="edit-weight" v-model="weight"
                        :placeholder="$t('tools.cole.placeholder.weight')" type="text"
                        v-decimal
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <div class="lg:tw-col-span-2 tw-text-right">
        <b-button variant="primary" @click="calculate">{{ $t('tools.cole.btn') }}</b-button>
      </div>

      <div v-if="calculated" class="lg:tw-col-span-2 tw-mt-2">
        <div class="tool-result">
          <template v-if="result">
            <strong v-if="result.category">{{ $t(`growth.categories.${result.category}`) }}</strong>
            <span v-else>{{ $t('tools.cole.bmi.underTwo') }}</span>
            <span class="text-muted tw-ml-2">{{ $t('tools.cole.bmi.resultPrefix') }}: {{ result.bmi }}</span>
          </template>
          <span v-else>{{ $t('tools.cole.bmi.checkValues') }}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { kidsBmi } from '@utils/bmi';

export default {
  data() {
    return {
      gender: 'M',
      years: null,
      months: null,
      height: null,
      weight: null,
      result: null,
      calculated: false,
    };
  },
  // a grade only shows next to the values it came from
  watch: {
    gender: 'clear',
    years: 'clear',
    months: 'clear',
    height: 'clear',
    weight: 'clear',
  },
  methods: {
    calculate() {
      const { gender, years, months, height, weight } = this;
      this.result = kidsBmi({ sex: gender, years, months, height, weight });
      this.calculated = true;
    },
    clear() {
      this.calculated = false;
    },
  },
};
</script>
